import * as _ from "lodash";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {
  ICalculatedMetrics,
  IMetricCalculator, IMetricCalculatorCalculationChangedEvent,
  IPeriod,
  IPeriodMetricContext
} from "../PA.UIM.Metric/PA.UIM.Metric.IF";
import {IMetricParameterSet, IMetrics} from "../PA.Metric.Services/PA.Metrics.IF";
import {Subscription} from "rxjs";
import {ModelingSessionBO} from "../PA.Model.BusinessObjects/ModelingSessionBO";
import {ITrialFitMetricSummary} from "../PA.Model.Services/ModelingSessionServices.IF";
import {ModelingSessionService} from "../PA.Model.Services/ModelingSessionService";


export class ModelingSessionGraphCalculator
  implements IMetricCalculator
{
  private _CalculationChanged: BehaviorSubject<IMetricCalculatorCalculationChangedEvent>;
  private _ModelingSessionBO: ModelingSessionBO
  private _CalcFinishedSub: Subscription
  private _wbModelingSessionTrialId: number = 0
  private _dctFitMetricSummary: {[periodId:string]: ITrialFitMetricSummary} = {}
  private _metricParameterSet: IMetricParameterSet = {}

  constructor(){

    this._ModelingSessionBO = undefined
    this._CalcFinishedSub = undefined
    this._CalculationChanged = new BehaviorSubject<IMetricCalculatorCalculationChangedEvent>(undefined)
    this._dctFitMetricSummary= {}

  }

  Register(aModelingSessionBO: ModelingSessionBO){
    const self = this

    self.UnRegister()

    self._ModelingSessionBO = aModelingSessionBO

    if(self._ModelingSessionBO){
      this._CalcFinishedSub = this._ModelingSessionBO.ModelingSessionCalculator.OnCalculateComplete.subscribe(self._OnCalculateComplete.bind(self))
    }

  }

  UnRegister(){

    if(this._CalcFinishedSub){
      this._CalcFinishedSub.unsubscribe()
      this._CalcFinishedSub = undefined
    }

    this._ModelingSessionBO = undefined
  }

  get wbModelingSessionTrialId(): number {
    return this._wbModelingSessionTrialId
  }

  set wbModelingSessionTrialId(value: number) {
    const self = this

    if(value != self._wbModelingSessionTrialId){
      self._wbModelingSessionTrialId = value
      self._reloadTrialMetrics()
    } else {
      self.notifyMetricCalculationChanged()
    }
  }



  private _OnCalculateComplete(){
    const self = this
    self._reloadTrialMetrics()
  }

  private async _reloadTrialMetrics(): Promise<void> {
    const self = this

    if(self._wbModelingSessionTrialId > 0){
      let aModelingService = new ModelingSessionService()
      let s = await aModelingService.SummarizeTrialFitMetrics(self._wbModelingSessionTrialId, self._metricParameterSet, {})
      if(s.bSuccess){
        self._dctFitMetricSummary = s.results
      } else {
        self._dctFitMetricSummary = {}
        // No Message Provider to feed errors.
      }
    } else {
      self._dctFitMetricSummary = {}
    }

    self.notifyMetricCalculationChanged(true)
  }

//<editor-fold desc = "IMetricsCalculator operations">

  get CalculationChanged(): BehaviorSubject<IMetricCalculatorCalculationChangedEvent> {
    return this._CalculationChanged
  }

  private notifyMetricCalculationChanged(bRecalcAll?: boolean){
    this.CalculationChanged.next({MetricCalculator: this, bRecalculateAll: bRecalcAll })
  }

  async BeforeCalcualteMetrics(pmc: IPeriodMetricContext, mps: IMetricParameterSet): Promise<void> {
    const self = this

    self._metricParameterSet = mps

    await self._reloadTrialMetrics()

  }

  async CalculateMetrics(pmc: IPeriodMetricContext, Period: IPeriod, inMetrics: IMetrics): Promise<ICalculatedMetrics> {
    const self = this

    let defaultMetricss: ITrialFitMetricSummary = {
      PREDICTED_UNITS: 0,
      PREDICTED_RTLSLS: 0,
      PREDICTED_BASE_UNITS: 0,
      PREDICTED_BASE_RTLSLS: 0,
      PREDICTED_INCR_UNITS: 0,
      PREDICTED_INCR_RTLSLS: 0,
      TARGET_OBSERVATION_UNITS: 0,
      TARGET_OBSERVATION_RTLSLS: 0,

      OBSERVATION_COUNT: 0,
      OBSERVATION_INCR_COUNT: 0,
      OBSERVATION_BASE_COUNT: 0,
      OBSERVATION_BASE_PCNT: 0,
      OBSERVATION_PROMOTED_PCNT: 0,


      RESIDUAL_MEAN: 0,
      RESIDUAL_STD_DEV: 0,
      RESIDUAL_MEAN_M1_STDDEV: 0,
      RESIDUAL_MEAN_P1_STDDEV: 0
    }

    if(Period.Id in self._dctFitMetricSummary)
      return self._dctFitMetricSummary[Period.Id]


      return defaultMetricss
  }



}





//</editor-fold>